/*=========================================================================================
  File Name: moduleDepartmentActions.js
  Description: Department Module Actions
==========================================================================================*/

import departmentGql from "@/http/requests/card/department_gql.js";

export default {
	fetchDepartments({ commit }, payload) {
		return new Promise((resolve, reject) => {
			departmentGql
				.fetchDepartments(payload)
				.then(response => {
					commit("SET_DEPARTMENTS", response.departments);
					resolve(response);
				})
				.catch(error => {
					// commit("SET_IS_FETCHED_DEPARTMENTS", false);
					reject(error);
				});
		});
	},
	toggleDepartmentCategorySideBar({ commit }, payload) {
		commit("SET_DEPARTMENT_CATEGORY_SIDEBAR_STATUS", payload.status);
	},
	updateDepartment({ commit }, payload) {
		return new Promise((resolve, reject) => {
			departmentGql
				.updateDepartment(payload)
				.then(response => {
					commit("UPDATE_DEPARTMENT", response.department);
					resolve(response);
				})
				.catch(error => {
					// commit("SET_IS_FETCHED_DEPARTMENTS", false);
					reject(error);
				});
		});
	},

	addDepartment({ commit }, payload) {
		return new Promise((resolve, reject) => {
			departmentGql
				.addDepartment(payload)
				.then(response => {
					commit("ADD_NEW_DEPARTMENT", response.department);
					resolve(response);
				})
				.catch(error => {
					// commit("SET_IS_FETCHED_DEPARTMENTS", false);
					reject(error);
				});
		});
	},

	deleteDepartment({ commit }, payload) {
		return new Promise((resolve, reject) => {
			departmentGql
				.deleteDepartment(payload)
				.then(response => {
					commit("DELETE_DEPARTMENT", response.department);
					resolve(response);
				})
				.catch(error => {
					// commit("SET_IS_FETCHED_DEPARTMENTS", false);
					reject(error);
				});
		});
	},
	getDetailDepartment({ commit }, payload) {
		return new Promise((resolve, reject) => {
			departmentGql
				.getDetailDepartment(payload)
				.then(response => {
					commit("UPDATE_DEPARTMENT", response.department);
					resolve(response);
				})
				.catch(error => {
					// commit("SET_IS_FETCHED_DEPARTMENTS", false);
					reject(error);
				});
		});
	}
};
